<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21 9L12 4L3 9L6 10.6667M21 9L18 10.6667M21 9V16M6 10.6667L12 14L18 10.6667M6 10.6667V17L12 20L18 17V10.6667" stroke="#1B262C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
